module.exports = __webpack_public_path__ + "img/banner-11.6f4a134a.jpg";